import React from 'react'

import {Box, Card, Grid, Stack, Typography, useTheme} from '@mui/material'

import CenteredContainer from '@progyny/components/CenteredContainer'
import ProgressBar from '@progyny/components/ProgressBar'

interface CommonContainerProps {
  headerTitle?: string
  children: React.ReactNode
  progressValue?: number
  progressBar?: boolean
  progressBarTitle?: string
  progressColor: {main: string; light?: string}
  description?: string
  alertBox?: React.ReactNode
  align?: string
  maxWidth?: string
}

const CommonContainer: React.ComponentType<CommonContainerProps> = ({
  progressColor,
  progressBar = true,
  progressBarTitle,
  headerTitle,
  children,
  progressValue,
  description,
  alertBox,
  align,
  maxWidth = '600px',
}: CommonContainerProps) => {
  const theme = useTheme()

  return (
    <Grid container justifyContent={'center'}>
      <Grid item xs={12}>
        <CenteredContainer
          align={align as 'top' | 'center' | 'bottom' | undefined}
        >
          <Card
            sx={{
              padding: {xs: 0, md: theme.spacing(8)},
              width: '100%',
              maxWidth: {xs: '100%', md: maxWidth},
              marginInline: 'auto',
              borderRadius: {xs: 0, md: '32px'},
              boxShadow: {xs: 'none', md: 1},
            }}
          >
            <Stack>
              {alertBox && alertBox}
              {(progressBarTitle || headerTitle || description) && (
                <Box
                  display={'flex'}
                  flexDirection={'column'}
                  alignItems={'center'}
                >
                  {progressBar && (
                    <Box
                      display={'flex'}
                      flexDirection={'column'}
                      justifyContent={'center'}
                      mb={5}
                      width={'60%'}
                    >
                      <ProgressBar
                        progressColor={progressColor}
                        title={progressBarTitle}
                        value={progressValue}
                      />
                    </Box>
                  )}
                  {headerTitle && (
                    <Box mb={3}>
                      <Typography variant={'h3'} textAlign={'center'}>
                        {headerTitle}
                      </Typography>
                    </Box>
                  )}
                  {description && (
                    <Box minHeight={theme.spacing(3)}>
                      <Typography variant={'body1'} textAlign={'center'}>
                        {description}
                      </Typography>
                    </Box>
                  )}
                </Box>
              )}
              {children}
            </Stack>
          </Card>
        </CenteredContainer>
      </Grid>
    </Grid>
  )
}

export default CommonContainer
